import type { Tutorial } from '../types'

const IMG = '/images/tutorials/web/collaborator-messaging'

export const collaboratorMessagingWebTutorial: Tutorial = {
  slug: 'collaborator-messaging',
  platform: 'web',
  title: 'Collaborator Messaging',
  subtitle: 'Partnership threads in the Messages inbox',
  date: '2026-07-09',
  category: 'Sharing & Support',
  tags: ['Messaging', 'Goals Partners', 'inbox'],
  description:
    'Partnership conversations sync between the partnership feed and the app-wide Messages inbox — one thread, two entry points.',
  highlights: [
    'Messages inbox at /messages lists every partnership conversation.',
    'Reply from the inbox or the partnership feed — same underlying thread.',
    'Reactions and legacy nudges render as status lines, not duplicate chat bubbles.',
  ],
  coverImage: `${IMG}/01-messages-inbox.png`,
  sections: [
    {
      heading: 'The Messages inbox',
      paragraphs: [
        '**Messages** in the sidebar shows every active partnership conversation with preview text and timestamps. Open a thread to reply — the same messages appear on the partnership feed.',
      ],
      image: {
        src: `${IMG}/01-messages-inbox.png`,
        alt: 'Messages inbox on Livewello web',
        caption: 'Messages inbox',
      },
    },
  ],
  whyMatters:
    'Partners supporting multiple goal owners need one inbox, not a separate feed per partnership buried in settings. Unified messaging on web matches how email and Slack work — one place to check.',
  relatedSlugs: ['accountability-partner-workflow'],
  meta: {
    description: 'Collaborator messaging on Livewello web: unified Messages inbox for partnership threads.',
    ogImage: `${IMG}/01-messages-inbox.png`,
  },
}
